import React, { useCallback } from "react";
import { connect } from "react-redux";

import { ICellRendererParams } from "@ag-grid-community/core";
import { useIntl } from "react-intl";

import { Company, EntityType } from "@mapmycustomers/shared/types/entity";
import { Person } from "@mapmycustomers/shared/types/entity";
import { primaryEntityComparator } from "@mapmycustomers/shared/util/comparator";

import EntityChip from "@app/component/EntityChip";
import useRowHeightUpdater from "@app/component/grid/util/hooks/useRowHeightUpdater";
import { showEntityView } from "@app/store/entityView/actions";

import styles from "./CompanyCellRenderer.module.scss";

interface Props extends ICellRendererParams {
  onShowEntityView: typeof showEntityView;
}

const CompaniesCellRenderer: React.FC<Props> = ({ api, node, onShowEntityView, value }) => {
  useRowHeightUpdater(node, api);
  const intl = useIntl();
  const handleOpenCompany = useCallback(
    ({ entityId, entityType }: { entityId: number; entityType: EntityType }) => {
      onShowEntityView({ entityId, entityType });
    },
    [onShowEntityView]
  );

  const primaryCompanyId = (node.data as Person).primaryAccountId ?? undefined;

  return (
    <div className={styles.container}>
      {((value ?? []) as Company[])
        .sort(primaryEntityComparator(primaryCompanyId))
        .map((company) => (
          <EntityChip
            className={styles.chip}
            entityId={company.id}
            entityType={EntityType.COMPANY}
            key={company.id}
            name={company.name}
            onClick={handleOpenCompany}
            primary={company.id === primaryCompanyId}
            tooltip={intl.formatMessage(
              {
                id: "grid.companiesCell.open",
                defaultMessage: "Open {primary, select, true {primary } other{}}Company",
                description: "Open Company tooltip",
              },
              { primary: company.id === primaryCompanyId }
            )}
          />
        ))}
    </div>
  );
};
const mapStateToProps = {
  onShowEntityView: showEntityView,
};

export default connect(null, mapStateToProps)(CompaniesCellRenderer);
